module.exports = __webpack_public_path__ + "img/findmykit-lifestyle-3.e1adcf36.png";